import { RootState } from "@/infrastructure/rootState";
import { pick } from "lodash";
import * as T from "./types";

export const anomalData = ({ anomal }: RootState) => anomal.data;
export const anomalyDate = ({ anomal }: RootState) => anomal.anomalyDate;

export const dataFetch = ({ anomal }: RootState) => anomal.loading.anomal;
export const isMetaLoading = ({ anomal }: RootState) => anomal.loading.meta === "REQUEST";
export const isIndustryMetaLoading = ({ anomal }: RootState) => anomal.loading.industryMeta === "REQUEST";
export const isFilterLoading = ({ anomal }: RootState) => anomal.loading.filter === "REQUEST";
export const isNavbarLoading = ({ anomal }: RootState) => anomal.loading.navbar === "REQUEST";

export const sectorIndustryMeta = ({ anomal }: RootState) =>
  pick(anomal.screener.meta, ["industry", "sector"]) as Pick<T.ScreenerMeta, "industry" | "sector">;
export const screenerMeta = ({ anomal }: RootState) => anomal.screener.meta;
export const navbarOptions = ({ anomal }: RootState) => anomal.screener.meta.navbarOptions;
export const criteriaOptions = ({ anomal }: RootState) => anomal.screener.meta.criteriaOptions;
export const customizedFilterOptions = ({ anomal }: RootState) => anomal.screener.meta.customizedFilterOptions;
export const fundamentalFilterOptions = ({ anomal }: RootState) => anomal.screener.meta.fundamentalFilterOptions;
export const screenerResult = ({ anomal }: RootState) => anomal.screener.result;
export const screenerSetup = ({ anomal }: RootState) => anomal.screener.setup;
export const selectedCountry = ({ anomal }: RootState) => anomal.screener.setup.country;
export const selectedIndustry = ({ anomal }: RootState) => anomal.screener.setup.industry;
export const selectedSector = ({ anomal }: RootState) => anomal.screener.setup.sector;
export const fundamentalSetup = ({ anomal }: RootState) => anomal.screener.setup.fundamental;

export const navbarData = ({ anomal }: RootState) => anomal.screener.navbar;
